import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllMPTensileStrengthVsTempTables = async (page, size, searchString) => {
    const response = await api.get(`/${ENDPOINTS.MP_TENSILE_STRENGTH_TEMP_TABLE}`, {
        params: { page, size, search: searchString },
    });

    return response.data;
};